import { environment } from "./environment";

export const BASE_API_URL = `${environment.apiUrl}/api`;
